import { render, staticRenderFns } from "./IconCurrencyBangladeshiSolid.vue?vue&type=template&id=3bc3a931"
import script from "./IconCurrencyBangladeshiSolid.vue?vue&type=script&lang=js"
export * from "./IconCurrencyBangladeshiSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports